import { render, staticRenderFns } from "./TasksMain.vue?vue&type=template&id=28100f14&"
import script from "./TasksMain.vue?vue&type=script&lang=js&"
export * from "./TasksMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports